<template>
    <div class="input-group mb-3 col-7">
        <div class="dropdown mr-2">
            <i class="fas fa-calendar-days icon icon-sm bg-soft-primary text-primary rounded-circle" role="button" data-bs-toggle="dropdown" aria-expanded="false"></i>
            <ul class="dropdown-menu">
                <li><a class="dropdown-item" @click.stop="changeDateRange('month')" href="#">{{ $trans.get("__JSON__.Last month") }}</a></li>
                <li><a class="dropdown-item" @click.stop="changeDateRange('week')" href="#">{{ $trans.get("__JSON__.Last week") }}</a></li>
                <li><a class="dropdown-item" @click.stop="changeDateRange('today')" href="#">{{ $trans.get("__JSON__.Today") }}</a></li>
                <li><a class="dropdown-item" @click.stop="changeDateRange('yesterday')" href="#">{{ $trans.get("__JSON__.Yesterday") }}</a></li>
            </ul>
        </div>
        <input id="pickstartdate" name="startdate" autocomplete="off" class="form-control">
        <span class="input-group-text date-selector-spacer">-</span>
        <input id="pickenddate" name="enddate" autocomplete="off" class="form-control">
        <input type="hidden" name="range" id="range" />
        <div class="ml-3 mt-1 journal-overview-buttons">
            <a @click.stop="moveDateRange('prev')" v-tooltip v-if="rangeSelected" :title="'prev ' + this.daterangename" class="btn btn-light ml-2"><i class="fa fa-chevron-left"></i><i class="fa fa-chevron-left"></i></a>
            <a @click.stop="moveDateRange('next')" v-tooltip v-if="rangeSelected" :title="'next ' + this.daterangename" class="btn btn-light ml-2"><i class="fa fa-chevron-right"></i><i class="fa fa-chevron-right"></i></a>
        </div>
        <div class="ml-3 mt-1 journal-overview-buttons">
            <input type="checkbox" v-model="displayBreaks" id="displaybreaks"> <label for="displaybreaks">{{ $trans.get('__JSON__.Display breaks') }}</label>
            <input type="hidden" name="breaks" id="breaks">
        </div>
    </div>
</template>

<script>
import { ref, watch } from "vue";

export default {
    name: "JournalSwitches",
    mounted() {
        this.rangeSelected = false;
        if (this.ranges.includes(this.daterange)) {
            this.rangeSelected = true;
            this.daterangename = this.rangeNames[this.ranges.indexOf(this.daterange)];
        }

        this.startpicker = datepicker('#pickstartdate', {
            onSelect: (instance, date) => {
                $('#selectForm').attr('method', 'get');
                $('#selectForm').submit();
            },
            dateSelected: this.startdate != '' ? new Date(this.startdate) : new Date(),
            formatter: (input, date, instance) => {
                input.value = date.getFullYear() + "-" + this.pad(date.getMonth() + 1, 2) + "-" + this.pad(date.getDate(), 2);
            },
            startDay: 1,
            id: 1
        });
        this.start = this.startpicker.dateSelected;

        this.endpicker = datepicker('#pickenddate', {
            onSelect: (instance, date) => {
                $('#selectForm').attr('method', 'get');
                $('#selectForm').submit();
            },
            dateSelected: this.enddate != '' ? new Date(this.enddate) : new Date(),
            formatter: (input, date, instance) => {
                input.value = date.getFullYear() + "-" + this.pad(date.getMonth() + 1, 2) + "-" + this.pad(date.getDate(), 2);
            },
            startDay: 1,
            id: 1
        });
        this.end = this.endpicker.dateSelected;
        this.displayBreaks = this.breaks;
    },
    data() {
        return {
            displayBreaks: null,
            start: null,
            end: null,
            rangeSelected: null,
            rangeSelectedName: null,
            startpicker: null,
            endpicker: null,
            daterangename: null,
            ranges: [
                'yesterday',
                'today',
                'week',
                'month',
            ],
            rangeNames: [
                'day',
                'day',
                'week',
                'month',
            ],
        };
    },
    props: {
        startdate: String,
        enddate: String,
        daterange: String,
        breaks: Boolean
    },
    watch: {
        displayBreaks(newValue, oldValue) {
            if (newValue) {
                $('#breaks').val(1);
            } else {
                $('#breaks').val(0);
            }

            if (oldValue != null) {
                $('#selectForm').submit();
            }
        }
    },
    methods: {
        changeDateRange(range) {
            var date = new Date();
            this.rangeSelected = true;
            this.rangeSelectedName = range;
            $('#range').val(this.rangeSelectedName);
            if (this.rangeSelectedName == 'month') {
                this.start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
                this.end = new Date(date.getFullYear(), date.getMonth(), 0);
            } else if (this.rangeSelectedName == 'week') {
                this.start = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 6 - date.getDay());
                this.end = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay());
            } else if (this.rangeSelectedName == 'today') {
                this.start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                this.end = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            } else if (this.rangeSelectedName == 'yesterday') {
                this.start = new Date(date.getFullYear(), date.getMonth(), date.getDate()-1);
                this.end = new Date(date.getFullYear(), date.getMonth(), date.getDate()-1);
            }
            this.clearDates();
            this.startpicker.setDate(this.start);
            this.endpicker.setDate(this.end);
            $('#selectForm').submit();
        },
        moveDateRange(dir) {
            var date = this.start;
            var enddate = this.end;
            this.clearDates();
            this.rangeSelected = true;
            this.rangeSelectedName = this.daterange;
            $('#range').val(this.rangeSelectedName);
            if (this.rangeSelectedName == 'month') {
                if (dir == 'prev') {
                    this.start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
                    this.end = new Date(date.getFullYear(), date.getMonth(), 0);
                } else if (dir == 'next') {
                    this.start = new Date(date.getFullYear(), date.getMonth() + 1, 1);
                    this.end = new Date(date.getFullYear(), date.getMonth() + 2, 0);
                }
            } else if (this.rangeSelectedName == 'week') {
                if (dir == 'prev') {
                    this.start = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 7);
                    this.end = new Date(enddate.getFullYear(), enddate.getMonth(), enddate.getDate() - 7);
                } else if (dir == 'next') {
                    this.start = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 7);
                    this.end = new Date(enddate.getFullYear(), enddate.getMonth(), enddate.getDate() + 7);
                }
            } else if (this.rangeSelectedName == 'today' || this.rangeSelectedName == 'yesterday') {
                if (dir == 'prev') {
                    this.start = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
                    this.end = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
                } else if (dir == 'next') {
                    this.start = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
                    this.end = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
                }
            }
            this.startpicker.setDate(this.start);
            this.endpicker.setDate(this.end);
            $('#selectForm').submit();
        },
        pad(num, size) {
            var s = "000000000" + num;
            return s.substr(s.length - size);
        },
        clearDates() {
            this.startpicker.setDate(null);
            this.endpicker.setDate(null);
        }
    },
};
</script>
